import React, { useEffect, useState } from 'react';
import axios from 'axios';
import Slider from 'react-slick';
import CertificationCard from './CertificationCard';
import './Certification.css';
import moment from 'moment';

function Certification() {
  const [certifications, setCertifications] = useState([]);

  useEffect(() => {
    axios.get('/data/data.json')
      .then((response) => {
        const sortedCertifications = response.data.certifications.sort((a, b) => {
          const dateA = moment(a.date, 'MMM YYYY').toDate();
          const dateB = moment(b.date, 'MMM YYYY').toDate();
          return dateB - dateA; // Sort in descending order (newest first)
        });
        setCertifications(sortedCertifications);
      })
      .catch((error) => {
        console.error('Error fetching certifications data:', error);
      });
  }, []);

  if (!certifications) {
    return <div style={{textAlign: 'center'}}>Loading Certifications...</div>; // Loading state until the data is fetched
  }

  var settings = {
    dots: true,
    infinite: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 2000,
    pauseOnHover: true
  };

  return (
    <div className="slider-container">
      <h2 data-heading="My Certification" className="section__title">Certification</h2>
      <Slider {...settings}>
        {certifications.map((cert, index) => (
          <CertificationCard key={index} image={cert.image} title={cert.title} date={cert.date} />
        ))}
      </Slider>
    </div>
  );
}

export default Certification;
